/**
 * Gestion du menu déroulant.
 */

import Collapse from 'bootstrap/js/dist/collapse';

(function () {
    /**
     * Charge et transforme le menu "à plat" retourné par Drupal en menu indexé
     */
    async function getMenuData(locale) {
        try {
            const response = await fetch('/' + locale + '/system/menu/main/linkset');
            if (!response.ok) {
                throw new Error(`Can't load menu data : ${reponse.status}`);
            }

            const menuData = await response.json();
            if (!menuData.linkset) {
                throw new Error(`Can't load menu data : ${reponse.status}`);
            }

            return menuData.linkset[0].item
                .reduce(
                    (normalizedMenuData, item) => {
                        let children = normalizedMenuData;
                        for (let i = 0; i < item.hierarchy.length - 1; ++i) {
                            children = children[item.hierarchy[i]].children;
                        }
                        children[item.hierarchy[item.hierarchy.length - 1]] = {
                            href: item.href,
                            title: item.title,
                            children: []
                        };
                        return normalizedMenuData;
                    },
                    {}
                );
        }
        catch (error) {
            console.error(error.message);
        }
    }

    function loadChildren(children) {
        if (children.length) {
            return children.reduce(
                (list, menu) => {
                    const item = document.createElement('li');
                    list.appendChild(item);

                    const link = document.createElement('a');
                    link.setAttribute('href', menu.href);
                    link.append(menu.title);
                    item.appendChild(link);

                    const subList = loadChildren(menu.children);
                    if (subList) {
                        item.appendChild(subList);
                    }

                    return list;
                },
                document.createElement('ul')
            );
        }
        return null;
    }

    document.addEventListener('DOMContentLoaded', async function() {
        // Initialise le panneau de menu                
        const mainMenuPanel = document.querySelector('.main-menu-panel');
        const menuPanelCollapse = new Collapse(
            mainMenuPanel,
            {
                toggle: false
            }
        );

        // Téléphone et tablette portrait (menu « burger ») : le panneau des sous-menus s'ouvre en
        // accordéon juste sous la rubrique touchée. Au-delà, il reste à sa place (pleine largeur sous
        // la barre de menu). Sa place d'origine est mémorisée pour l'y remettre.
        const mobileQuery = window.matchMedia('(max-width: 991.98px)');
        const panelHome = { parent: mainMenuPanel.parentNode, next: mainMenuPanel.nextSibling };
        function placePanel(linkTag) {
            const target = mobileQuery.matches ? linkTag.closest('.nav-item') : null;
            if (target) {
                target.appendChild(mainMenuPanel);
            }
            else if (mainMenuPanel.parentNode !== panelHome.parent) {
                panelHome.parent.insertBefore(mainMenuPanel, panelHome.next);
            }
        }
        // Changement d'orientation ou de largeur : on referme le panneau et on le remet en place.
        mobileQuery.addEventListener('change', function() {
            mainMenuPanel.removeAttribute('data-current');
            document.querySelectorAll('.navbar-nav .nav-item a.is-expand').forEach((a) => a.classList.remove('is-expand'));
            mainMenuPanel.classList.remove('show');
            if (mainMenuPanel.parentNode !== panelHome.parent) {
                panelHome.parent.insertBefore(mainMenuPanel, panelHome.next);
            }
        });

        // Charge les données de menu
        const menuData = await getMenuData(document.querySelector('html').getAttribute('lang'));

        // Gère le clic sur les menus principaux pour ouvrir le panneau des sous-menus
        const topLevelMenus = [...document.querySelectorAll('.navbar-nav .nav-item a')];
        topLevelMenus.forEach((linkTag) => {
            const internalLink = linkTag.getAttribute('data-drupal-link-system-path');
            const aliasLink = linkTag.getAttribute('href');
            const menu = Object.values(menuData).find((menu) =>
                menu.href.endsWith(internalLink) || menu.href.endsWith(aliasLink)
            );
            if (menu) {
                linkTag.addEventListener('click', function(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    // Fermeture du panneau si le menu cliqué est déjà celui affiché
                    if (mainMenuPanel.getAttribute('data-current') == menu.href) {
                        mainMenuPanel.removeAttribute('data-current');
                        linkTag.classList.remove('is-expand');
                        menuPanelCollapse.hide();
                        return;
                    }
                    topLevelMenus.forEach((linkTag) => linkTag.classList.remove('is-expand'));
                    // Sur téléphone, passage d'une rubrique à l'autre : le panneau est refermé
                    // instantanément avant d'être déplacé sous la nouvelle rubrique.
                    if (mobileQuery.matches && mainMenuPanel.parentNode !== linkTag.closest('.nav-item')) {
                        mainMenuPanel.classList.remove('show');
                    }
                    placePanel(linkTag);

                    // Affichage du menu parent
                    const parentMenu = mainMenuPanel.querySelector('.parent-menu');
                    while (parentMenu.firstChild) parentMenu.removeChild(parentMenu.firstChild);
                    const link = document.createElement('a');
                    link.setAttribute("href", menu.href);
                    link.append(menu.title);
                    parentMenu.appendChild(link);

                    // Affichage des menus enfants
                    const childrenMenu = mainMenuPanel.querySelector('.children-menu');
                    while (childrenMenu.firstChild) childrenMenu.removeChild(childrenMenu.firstChild);
                    const list = loadChildren(menu.children);
                    if (list) {
                        childrenMenu.appendChild(list);
                    }

                    mainMenuPanel.setAttribute('data-current', menu.href);
                    linkTag.classList.add('is-expand');
                    menuPanelCollapse.show();
                });
            }
        });

        // Fermeture du panneau si click en dehors
        window.addEventListener('click', function(event) {
            let matching = topLevelMenus.some((menu) => menu.contains(event.target));
            if (!matching) {
                matching = mainMenuPanel.contains(event.target);
            }
            if (!matching) {
                mainMenuPanel.removeAttribute('data-current');
                topLevelMenus.forEach((linkTag) => linkTag.classList.remove('is-expand'));
                menuPanelCollapse.hide();
            }
        });

        // Shrink menu when page is scrolled
        function manageHeaderSize() {
            const pageHeader = document.querySelector('.page-header');
            if (pageHeader) {
                if (document.body.scrollTop > pageHeader.clientHeight || document.documentElement.scrollTop > pageHeader.clientHeight) {
                    pageHeader.classList.add('shrinked');
                }
                else if (document.body.scrollTop <= 0 || document.documentElement.scrollTop <= 0) {
                    pageHeader.classList.remove('shrinked');
                }
            }
        };

        window.onscroll = manageHeaderSize;
        manageHeaderSize();
    });
})();